/**
 * Business Hours Ball
 * -------------------
 */

if($('.business-hours-ball').length) {

    let ballObject = $('.business-hours-ball'),
        pillContainer = ballObject.find('.pill-selection'),
        pillIndicator = ballObject.find('.pill-indicator'),
        moreInfoContainerMuseum = ballObject.find('.more-info-museum'),
        moreInfoContainerCafe = ballObject.find('.more-info-cafe'),
        hoursDisplay = ballObject.find('.hours-display'),
        selectionItems = ballObject.find('.display-selection');

    setBallSize();
    $(window).on('resize', function () {
        setBallSize()
    });

    function setBallSize() {
        if($(window).width() > 768) {
            ballObject.css('height', ballObject.outerWidth());
        } else {
            ballObject.css('height', '');
        }
    }

    selectionItems.on('click', function () {
        let selection = $(this).data('selection'),
            hours = $(this).data('hours');

        setHoursLabel(hours);

        if(selection === "cafe") {
            pillIndicator.addClass('set-to-cafe').delay(150).html('Café');
            showCafeMoreInfo();
        } else {
            pillIndicator.removeClass('set-to-cafe').delay(150).html('Museum');
            showMuseumMoreInfo();
        }
    });

    function showCafeMoreInfo() {
        moreInfoContainerMuseum.addClass('hiding');

        setTimeout(function () {
            moreInfoContainerMuseum.addClass('d-none');
            moreInfoContainerCafe.removeClass('d-none');
        }, 310);

        setTimeout(function () {
            moreInfoContainerCafe.removeClass('hiding');
        }, 320);
    }

    function showMuseumMoreInfo() {
        moreInfoContainerCafe.addClass('hiding');

        setTimeout(function () {
            moreInfoContainerCafe.addClass('d-none');
            moreInfoContainerMuseum.removeClass('d-none');
        }, 310);

        setTimeout(function () {
            moreInfoContainerMuseum.removeClass('hiding');
        }, 320);
    }

    function setHoursLabel(hours) {
        hoursDisplay.addClass('hiding');
        setTimeout(function () { hoursDisplay.html(hours); }, 310);
        setTimeout(function () { hoursDisplay.removeClass('hiding'); }, 320);
    }

}